// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle--toggle--ND00j","on":"Toggle--on--2lvkH","disabled":"Toggle--disabled--1_QcG"};